import {
  SettingsFormControl,
  SettingsGroup,
  Switch
} from '@sequencehq/core-components'
import { useLiveState } from 'hooks/useLiveState'
import type { RevenueRecognitionSettingsControls } from './revenueRecognitionSettings.types'

export const RecognitionStartSettings = (
  props: RevenueRecognitionSettingsControls
) => {
  const [
    recognizeRevenueOnAccountingDate,
    setRecognizeRevenueOnAccountingDate
  ] = useLiveState(props.settings?.recognizeRevenueOnAccountingDate ?? false)

  const handleToggleRecognitionFromInvoiceDate = (enabled: boolean) => {
    const settings = props.settings

    if (
      !settings ||
      props.isUpdating ||
      enabled === recognizeRevenueOnAccountingDate
    ) {
      return
    }

    const previousRecognizeRevenueOnAccountingDate =
      recognizeRevenueOnAccountingDate
    setRecognizeRevenueOnAccountingDate(enabled)
    props.updateSettings(
      {
        recognizeRevenueOnAccountingDate: enabled,
        allocationPartialProrationStrategy:
          settings.allocationPartialProrationStrategy,
        integrationsJournalPostMode: settings.integrationsJournalPostMode
      },
      () => {
        setRecognizeRevenueOnAccountingDate(
          previousRecognizeRevenueOnAccountingDate
        )
      }
    )
  }

  return (
    <SettingsGroup
      title="Recognition start"
      footer="Controls whether revenue recognition starts from the invoice date."
      isLoading={props.isLoading}
    >
      <SettingsFormControl
        label="Recognize revenue from invoice date"
        htmlFor="recognize-revenue-from-invoice-date"
        showBorderBottom={false}
      >
        <Switch
          size="md"
          id="recognize-revenue-from-invoice-date"
          as="div"
          data-testid="revenueRecognition.settings.recognizeRevenueOnAccountingDate"
          isChecked={recognizeRevenueOnAccountingDate}
          disabled={!props.settings || props.isUpdating}
          onChange={handleToggleRecognitionFromInvoiceDate}
        />
      </SettingsFormControl>
    </SettingsGroup>
  )
}
